module.exports = __webpack_public_path__ + "static/media/103.599447c1.jpeg";